import { AxiosRequestConfig } from 'axios';
import { CustomerOrderLookupDto } from 'src/common/interfaces/dtos/ICustomerOrderLookup';
import { CartLookupData } from 'src/common/interfaces/dtos/ICartLookupData';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const customerOrderLookup = async (
  params: CustomerOrderLookupDto,
): Promise<CartLookupData[]> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: '/order-management/orders',
    params: params,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<CartLookupData[]>(emeraldRequestParams);
};
